module.exports = ":root{--lui-tabbar-border-radius:calc(4 * var(--lui-border-radius));--lui-tabbar-selected-height:0;--lui-tabbar-selected-left:0;--lui-tabbar-selected-top:0;--lui-tabbar-selected-width:0;--lui-tabbar-marker-thickness:2px;--lui-tabbar-marker-border-radius:1px;--lui-tabbar-horizontal-gutter:16px;--lui-tabbar-vertical-gutter:0px}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-tabbar/theme/lui-tabbar.global.scss
// module id = 344
// module chunks = 0 1 6